<template>
	<div>
		<div class="display-1 font-weight-light mb-3">Queue</div>
		<timezone />

		<v-row>
			<v-col cols="2" >
				<v-switch v-model="refreshing" label="Auto-Refresh" ></v-switch>
			</v-col>
			<v-col class="" cols="2">
				<v-text-field label="Refresh" v-model.number="refresh" suffix="seconds" v-mask="'##'"></v-text-field>
			</v-col>
			<v-col cols="auto" ></v-col>
		</v-row>

		<v-data-table :items="queue" :headers="headers" :loading="loading" item-key="id">
			<template v-slot:item="props">
				<tr>
					<td>{{props.item.id}}</td>
					<td>{{props.item.message.Region}}</td>
					<td><tracking :number="props.item.message.TrackingNumber" /></td>
					<td>{{formatDateTime(props.item.insertionTime)}}</td>
					<td>{{formatDateTime(props.item.expirationTime)}}</td>
					<td>{{props.item.dequeueCount}}</td>
				</tr>
			</template>
			<template v-slot:no-data>
				Queue is Empty
			</template>
		</v-data-table>
		<v-row>
			<v-col>
				<v-card dark color="blue-grey lighten-5">
					<v-btn color="warning" @click="confirming = true" :disabled="queue.length === 0">Delete Oldest Message</v-btn>
					<v-btn v-if="confirming" @click="dequeue" color="success">Confirm</v-btn>
					<v-btn v-if="confirming" @click="confirming = false">Cancel</v-btn>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mask } from "vue-the-mask";
import tracking from "../components/tracking-number.vue";
import api from "../api";
import timezone	from "../components/timezone.vue";

// TODO, update settings to work against local
// TODO, add environment switch

export default {
	props: [],
	components: {
		tracking,
		timezone,
	},
	directives: { mask },
	data() {
		return {
			headers: [
				{ text: "ID", value: "id" },
				{ text: "Region", value: "message.Region" },
				{ text: "Tracking #", value: "message.TrackingNumber" },
				{ text: "Insertion", value: "insertionTime" },
				{ text: "Expiration", value: "expirationTime" },
				{ text: "Dequeue Count", value: "dequeueCount" },
			],
			queue: [],
			loading: false,
			confirming: false,
			timer: null,
			refresh: 10,
			refreshing: true,
		};
	},
	created() {
		this.startTimer();
	},
	computed: {
	},
	watch: {
		refreshing(v) {
			if (v) {
				this.startTimer();
			} else {
				this.cancelTimer();
			}
		},
		refresh() {
			this.cancelTimer();
			this.refreshing = false;
		},
	},
	methods: {
		loadQueue() {
			this.loading = true;
			api.queue().then((r) => {
				this.queue = r.data.map(m => Object.assign(m, { message: JSON.parse(m.messageText) }));
				this.loading = false;
			}, (e) => {
				this.showError(e);
				this.loading = false;
			});
		},
		dequeue() {
			this.confirming = false;

			api.dequeue().then(() => this.loadQueue());
		},
		cancelTimer() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		startTimer() {
			if (!this.refresh || this.refresh < 1) {
				this.refreshing = false;
			}

			this.cancelTimer();
			this.loadQueue();
			this.timer = setInterval(this.loadQueue, this.refresh * 1000);
		},
	},
	beforeDestroy() {
		this.cancelTimer();
	},
};
</script>
